import { GraduationServicePath } from "utils/constants";
import permissions from "app/permissions";
import ListStateExamsResults from "./List";

export const resources = {
  isMenu: false,
  name: GraduationServicePath + "state-exams-results/:id",
  title: "Резултати държавен изпит",
  list: <ListStateExamsResults />,
  permission: permissions.canPreviewStateExamResults,
};
